import { useQuery } from 'data-fetching-client';
import { GET_LEGACY_CBES } from 'flow-doctor-lib/queries/LegacyCBEQueries';
const useLegacyCBE = ({
  portalId,
  cbeId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_LEGACY_CBES, {
    variables: {
      portalId
    }
  });
  const dataToReturn = data ? data.legacyCBEs.find(cbeDescriptor => cbeDescriptor.id === cbeId) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useLegacyCBE;